import { useEffect } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { saveTrip } from "@/lib/offline";

const KEY = "vv_notified";

async function check(uid) {
  const { data } = await api.get("/itinerary");
  saveTrip(uid, data);
  const done = new Set(JSON.parse(localStorage.getItem(KEY) || "[]"));
  const now = Date.now();
  data.forEach((e) => {
    if (!e.start_at || done.has(e.id)) return;
    const mins = (new Date(e.start_at).getTime() - now) / 60000;
    if (mins <= 0 || mins > 60) return;
    const body = `${e.listing.name} starts at ${e.time} (in ${Math.round(mins)} min)`;
    if ("Notification" in window && Notification.permission === "granted") new Notification("VacaVibe reminder", { body });
    toast.info("Coming up soon", { description: body, duration: 15000 });
    done.add(e.id);
  });
  localStorage.setItem(KEY, JSON.stringify([...done]));
}

export function ReminderWatcher() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    const run = () => check(user.id).catch(() => {});
    run();
    const t = setInterval(run, 60000);
    return () => clearInterval(t);
  }, [user]);
  return null;
}
